import { useEffect, useState } from 'react';

export const useIsClient = () => {
  const [isClientSide, setIsClientSide] = useState(false);

  useEffect(() => {
    setIsClientSide(typeof window !== 'undefined');
  }, []);

  return isClientSide;
};
